import type { LucideIcon } from "lucide-react";

interface KpiTileProps {
  icon: LucideIcon;
  iconColor?: "blue" | "green" | "orange" | "purple" | "red" | "indigo";
  label: string;
  value: string | number;
  trend?: string;
  trendDirection?: "up" | "down" | "neutral";
  /** NFR-DATA-001 / BR-011 — when a figure isn't backed by real computed data, say so plainly. */
  illustrative?: boolean;
}

const ICON_BG: Record<string, string> = {
  blue: "bg-status-blue-bg text-brand-blue-dark",
  green: "bg-status-green-bg text-status-green",
  orange: "bg-status-orange-bg text-status-orange",
  purple: "bg-status-purple-bg text-status-purple",
  red: "bg-status-red-bg text-status-red",
  indigo: "bg-status-indigo-bg text-status-indigo",
};

export function KpiTile({ icon: Icon, iconColor = "blue", label, value, trend, trendDirection = "neutral", illustrative }: KpiTileProps) {
  return (
    <div className="card p-4">
      <div className="flex items-center gap-2.5 mb-2.5">
        <div className={`w-8 h-8 rounded-md flex items-center justify-center flex-shrink-0 ${ICON_BG[iconColor]}`}>
          <Icon size={16} strokeWidth={2.25} />
        </div>
        <div className="text-xs font-semibold text-ink-muted">{label}</div>
      </div>
      <div className="text-xl font-extrabold leading-tight">{value}</div>
      {trend && (
        <div
          className={`text-[11px] font-bold mt-1 ${
            trendDirection === "up" ? "text-status-green" : trendDirection === "down" ? "text-status-red" : "text-ink-muted"
          }`}
        >
          {trend}
        </div>
      )}
      {illustrative && <div className="text-[10px] text-ink-muted mt-1 italic">Illustrative — no live data source yet</div>}
    </div>
  );
}
